import { defineNuxtRouteMiddleware, navigateTo, useNuxtApp } from '#imports'
import { getIsNotFoundApiError } from '@/composables/api-client'
import { FANTASY_LIST_PATH } from '@/composables/fantasy'
import { useFantasySeasonStore } from '@/stores/fantasy/season'

/**
 * Применяется к страницам, требующим наличие активного незавершенного сезона Fantasy.
 * Есть активный сезон и он не завершен - страница откроется.
 * Есть активный сезон, но он завершен - редирект на страницу этого сезона.
 * Нет активного сезона - редирект на список сезонов Fantasy
 */
export default defineNuxtRouteMiddleware(async () => {
  if (process.server) {
    return
  }

  const { $normalizePath } = useNuxtApp()
  const fantasySeasonStore = useFantasySeasonStore()

  try {
    const season =
      fantasySeasonStore.data ?? (await fantasySeasonStore.fetchData())

    if (!season?.is_completed) {
      return
    }

    return navigateTo($normalizePath(`/fantasy/${season.id}`), {
      replace: true
    })
  } catch (error) {
    if (getIsNotFoundApiError(error)) {
      return navigateTo($normalizePath(FANTASY_LIST_PATH), {
        replace: true
      })
    }

    throw error
  }
})
